import App from './App';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import { FirebaseProvider, store } from 'common';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProviderApp } from 'components/Theme/theme';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const config = {
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
}

root.render(
    <HelmetProvider>
        <Provider store={store}>
            <FirebaseProvider config={config as any}>
                <ThemeProviderApp>
                    <App />
                </ThemeProviderApp>
            </FirebaseProvider>
        </Provider>
    </HelmetProvider>
);